__turbopack_context__.v({
  "gradientOverlay": "Czj1hq_gradientOverlay",
});
